import React, { useEffect, useCallback } from 'react';
import GridPlate from 'spark-ui/ui-kitchen/plates/GridPlate';
import { GridProvider, WithResults, GridBody, PaginationFooter, WithoutResults } from 'spark-grid'; 
import { useSelector, useDispatch } from 'react-redux';
import { unregisterGrid, refreshGrid } from 'spark-grid';
import TableWrapper from 'spark-ui/Grid/TableWrapper';
import styles from '../styles/GapPacketStyles';
import withStyles from 'material-ui/styles/withStyles';
import { getGapPacketListForRecipient } from 'spark-api/gapPacket/gapPacketService';
import { setRecipientGapPacketList } from 'spark-state/gapPacket/gapPacketReducer';
import { userCurrentEnterprise } from 'spark-state/common/user/userReducer';
import { reset } from 'redux-form';
import RecipientGridHeader from './RecipientGridHeader';
import RecipientGridRow from './RecipientGridRow';


export const RecipientResultsGridName = 'GapPacketRecipientResultsGrid';

const GapPacketResultsGrid = ({ gridName, classes }) => {
	const enterpriseId = useSelector(state => userCurrentEnterprise(state));
	const dispatch = useDispatch();

	const reloadData = useCallback(() => dispatch(refreshGrid('GapPacketRecipientResultsGrid')), [dispatch]);
	const unregister = useCallback(() => {
		dispatch(reset('gapPacketForm'));
		dispatch(unregisterGrid('GapPacketRecipientResultsGrid'));
	}, [dispatch]);

	useEffect(() => {
		reloadData();
	}, [enterpriseId, reloadData]);

	useEffect(() => () => unregister(), [unregister]);

	return (
		<GridProvider
			name='GapPacketRecipientResultsGrid' 
			loadData={getGapPacketListForRecipient}
			onDataReceived={setRecipientGapPacketList}
			retainOnUnmount
		>
			<GridPlate.Layout>
				<WithResults>
					<GridPlate.Content>
						<TableWrapper>
							<RecipientGridHeader />
							<GridBody rowComponent={RecipientGridRow} />
							<PaginationFooter gridName={gridName}/>
						</TableWrapper>
					</GridPlate.Content>
				</WithResults>
				<WithoutResults>
					<span>No Gap Packet found to acknowledge</span>
				</WithoutResults>
			</GridPlate.Layout>
		</GridProvider>
	);
};

export default withStyles(styles)(GapPacketResultsGrid);
